import { useState } from "react";
import "./FAQ.css";
import { FaChevronDown } from "react-icons/fa";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const data = [
    {
      q: "Do you release pledged gold?",
      a: "Yes, we release pledged gold from banks, NBFCs and financial institutions safely.",
    },
    {
      q: "What documents do we need to bring when selling gold?",
      a: "You need valid ID proof such as Aadhaar, PAN card, or Passport.",
    },
    {
      q: "What is the store timings?",
      a: "We are open from 10 AM to 8 PM on all working days.",
    },
    {
      q: "What kind of jewelry is purchased here?",
      a: "We accept all types of gold jewelry, coins, and bars.",
    },
    {
      q: "What is the payment mode?",
      a: "Payment via cash, cheque, NEFT, or online transfer.",
    },
  ];

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section className="faq-section">

      <h2 className="faq-title">Frequently Asked Questions</h2>

      <div className="faq-wrapper">
        {data.map((item, i) => (
          <div
            key={i}
            className={`faq-card ${openIndex === i ? "open" : ""}`}
            onClick={() => toggle(i)}
          >
            <div className="faq-row">

              {/* QUESTION */}
              <p className="faq-question">{item.q}</p>

              {/* ICON */}
              <div className="faq-icon">
                <FaChevronDown />
              </div>

            </div>

            {/* ANSWER */}
            <div className="faq-answer">
              <p>{item.a}</p>
            </div>

          </div>
        ))}
      </div>

    </section>
  );
}